import React, { useEffect, useState } from 'react'
import Button from '../../common/Button'
import warning from "../assets/warning.png";
import ImModuleStyle from '../styles/im.module.css';


const CalProfitLoss = ({ popupState }) => {
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, accordionPopup, setAccordionPopup, simObj, setSimObj, formatNum, toggleSimulation, kpisPopup, setKpisPopup,isCalculatorOpen,closeKpisPopup] = popupState;
  const inventoryLeft = simObj?.laststate?.inventoryLeft;
  const dailyDemand = simObj?.laststate?.dailyDemand;
  const grossUnitsSold = simObj?.laststate?.grossUnitsSold;
  const grossRevenue = simObj?.laststate?.grossRevenue;
  const grossCost = simObj?.laststate?.grossCost;
  const yearlyProfitTarget = Number(simObj?.laststate?.yearlyProfitTarget?.toString().replace(/,/g, ''));
  const grossProfit = simObj?.laststate?.grossProfit;
  const progressbar = { "valuemin": 0, "valuemax": simObj?.laststate?.yearlyProfitTarget, "valuenow": function () { return (Math.round((simObj?.laststate?.grossProfit / this.valuemax) * 100)) } }
  const [weeksRemaining, setWeeksRemaining] = useState(0);
  const [shouldRenderSpan, setShouldRenderSpan] = useState(false);
  const [kpisPopupTop, setKpisPopupTop] = useState(0);
  const [plPopupTop, setPlPopupTop] = useState(0);
  const [ulPopupTop, setUlPopupTop] = useState(0);
  let costPerUnit = 0;
  const isCompleted = simObj?.completed;
  simObj.actions?.map(function (action) {
    costPerUnit = action.options.costPerUnit;
  })

  const closePlPopUp = () => {
    setPlPopup(false);
    setUlPopup(true);
  }
  const closeUlPopUp = () => {
    setUlPopup(false);
    setAccordionPopup(true);
  }

  const calculateWeeksRemaining = () => {
    if (simObj) {
      const newWeeksRemaining = Math.ceil((365 - simObj?.currentstep) / 7);
      if (weeksRemaining !== newWeeksRemaining) {
        setWeeksRemaining(newWeeksRemaining);
        setShouldRenderSpan(true);
      } else {
        setShouldRenderSpan(false);
      }
      //console.log(newWeeksRemaining,weeksRemaining)
    }
  };

  useEffect(() => {
    calculateWeeksRemaining();
  }, [simObj?.currentstep]);

  useEffect(() => {
    const handleResize = () => {
      if(kpisPopup && document.getElementsByClassName("ui pointing label")[0] != null){
        let top = document.getElementsByClassName(`${ImModuleStyle["profit-loss"]}`)[0].clientHeight + 10;
        setKpisPopupTop(top);
      }
      if(plPopup && document.getElementsByClassName("ui pointing label")[0] != null){
        let top = document.getElementsByClassName(`${ImModuleStyle["pl-progress"]}`)[0].clientHeight;
        setPlPopupTop(top);
      }
      if(ulPopup && document.getElementsByClassName("ui pointing label")[0] != null){
        let top = document.getElementsByClassName(`${ImModuleStyle["units-left"]}`)[0].clientHeight;
        setUlPopupTop(top);
      }
    }
    window.addEventListener('resize', handleResize);
    handleResize();
  },[kpisPopup, plPopup, ulPopup])
  return (

    <div className={`${ImModuleStyle['profit-loss']}`} style={{"position":"relative"}}>
      <div className={` ${kpisPopup ? `show ${ImModuleStyle['show']}` : ''}`}>
        {
          (shouldRenderSpan && (simObj.status != 'COMPLETED') && toggleSimulation) && (<span aria-live="assertive" role="alert" className={`sr-only pl-hiddenspan`}>
            {Math.ceil((365 - simObj?.currentstep) / 7)} weeks remaining <br />
            Demand: {formatNum(Math.round(dailyDemand != undefined ? dailyDemand : 0))} <br />
            Total Units Sold: {formatNum(Math.round(grossUnitsSold != undefined ? grossUnitsSold : 0))}<br />
            Total Revenue: ${formatNum(Math.round(grossRevenue != undefined ? grossRevenue : 0))}<br />
            Total Costs: ${formatNum(Math.round(grossCost != undefined ? grossCost : 0))} <br />
            Profit/Loss: ${formatNum((grossProfit == undefined) ? 0 : Math.round(grossProfit))} <br />
            Goal: ${formatNum(Math.round(yearlyProfitTarget))}
          </span>)
        }
        <div className={`${`${ImModuleStyle['units-left']}`} ${ulPopup ? `show ${ImModuleStyle['show']}` : ''}`}>
          <div>
            <h3 className={`${ImModuleStyle['pl-header']}`}>Units Left</h3>
            <div >
              <p className={`us-content ${ImModuleStyle.bld}`}>{Math.round(inventoryLeft != undefined ? inventoryLeft : 0)}</p>
              {
                (simObj.completed == 1 && inventoryLeft > 0) ?
                  <div aria-live='assertive' className={`${ImModuleStyle.warning}`} data-tooltip={`${inventoryLeft} units were not sold at the end of the year; these units were liquidated and you were refunded $${costPerUnit} per unit. The liquidation refund has been added to your total profit.`} aria-label={`${inventoryLeft} units were not sold at the end of the year; these units were liquidated and you were refunded $${costPerUnit} per unit. The liquidation refund has been added to your total profit.`} data-position="bottom center">
                    <img src={warning} alt="" />
                  </div>

                  : ""
              }
            </div>
          </div>
          {
            ulPopup ? <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Units left popup" style={{top:ulPopupTop+"px"}}>
              <p>Keep an eye on your Units Left to make sure you know when to place an order so you don't run out of stock! Remember lead time for a Normal order is 5 days and Expedited order is 1 day.</p>
              <div className={`${ImModuleStyle.dflex} ${ImModuleStyle.mt10}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnId="btnNext1" btnParentClassName={`${ImModuleStyle.ml10}`} btnWidth="80" clickEventHandler={closeUlPopUp} />
              </div>
            </div> : ''
          }
        </div>
        <div className={`demand`}>
          <h3 className={`${ImModuleStyle['pl-header']}`}>Demand</h3>
          <p className={`us-content tc-content ${ImModuleStyle.bld}`}>{formatNum(Math.round(dailyDemand != undefined ? dailyDemand : 0))}</p>
        </div>
        <div className={`units-sold`}>
          <h3 className={`${ImModuleStyle['pl-header']}`}>Total Units Sold</h3>
          <p className={`us-content tc-content ${ImModuleStyle.bld}`}>{formatNum(Math.round(grossUnitsSold != undefined ? grossUnitsSold : 0))}</p>
        </div>
        <div className={`tot-revenue`}>
          <h3 className={`${ImModuleStyle['pl-header']}`}>Total Revenue</h3>
          <p className={`tr-content tc-content ${ImModuleStyle.bld}`}>${formatNum(Math.round(grossRevenue != undefined ? grossRevenue : 0))}</p>
        </div>
        <div className={`tot-costs`}>
          <h3 className={`${ImModuleStyle['pl-header']}`}>Total Costs</h3>
          <p className={`tc-content ${ImModuleStyle.bld}`}>${formatNum(Math.round(grossCost != undefined ? grossCost : 0))}</p>
        </div>
        <div className={`${ImModuleStyle['pl-progress']}`}>
          <div className={`${plPopup ? `show ${ImModuleStyle['show']}` : ''}`}>
            <h3 className={`${ImModuleStyle['pl-header']}`}>Profit/Loss</h3>
            <p className={`${ImModuleStyle['pl-amt']}`} style={{ "color": (grossProfit < 0) ? '#B90000' : (grossProfit == undefined || grossProfit == 0) ? "#000" : '#156815' }}>${formatNum((grossProfit == undefined) ? 0 : Math.round(grossProfit))}</p>
            <div className={`${ImModuleStyle.progress}`} role="progressbar"
              aria-valuenow={progressbar.valuenow()}
              aria-valuemin={progressbar.valuemin}
              aria-valuemax={progressbar.valuemax}
              aria-valuetext={`${progressbar.valuenow()}%`}>
              <div className={`background`} id={`${ImModuleStyle.profitLoss}`}>
                <div className={`${ImModuleStyle['progress-fg']}`} style={{ "width": (grossProfit == undefined) ? "0%" : (((grossProfit < 0 ? Math.round(Math.abs(grossProfit)) : grossProfit) / yearlyProfitTarget) * 100) + '%', "background": (grossProfit < 0) ? '#B90000' : '#156815' }}></div>
              </div>
            </div>
            <p className={`${ImModuleStyle['goal-amt']}`}>Goal: ${formatNum(Math.round(yearlyProfitTarget))}</p>
          </div>
          {
            plPopup ? <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label='Profit loss indicator popup' style={{top:plPopupTop+"px"}}>
              <p>Your goal is to earn ${formatNum(Math.round(yearlyProfitTarget))} in profits from Amulet sales within a year.</p>
              <div className={`${ImModuleStyle.dflex} ${ImModuleStyle.mt10}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnId="btnNext1" btnParentClassName={`${ImModuleStyle.ml10}`} btnWidth="80" clickEventHandler={closePlPopUp} />
              </div>
            </div> : ''

          }
        </div>
      </div>
      {
        kpisPopup ? <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['kpis-popup']}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label='Key Performance Indicators popup' style={{top:kpisPopupTop+"px"}}>
          <p>Keep an eye on these Key Performance Indicators (KPIs) to know how well you're doing against the goal.</p>
          <div className={`${ImModuleStyle.dflex} ${ImModuleStyle.mt10}`}>
            <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
            <Button btnName="Next" btnId="btnNext1" btnParentClassName={`${ImModuleStyle.ml10}`} btnWidth="80" clickEventHandler={closeKpisPopup} />
          </div>
        </div> : ''
      }
    </div>
  )
}

export default CalProfitLoss
